import { observable } from "mobx";
import MyAccountStoreAction from "./actions";

class MyAccountStoreClass extends MyAccountStoreAction {
  @observable savedCards = [];
}

export default MyAccountStoreClass;
